
































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Monitoring24JamIcuSvc from "@/services/Monitoring24JamIcu";
import { appModule } from "@/store/modules/app";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import Monitoring24JamIcuNyeriInput from "./Monitoring24JamIcuNyeriInput.vue";
import {
  composeDate,
  toDateString,
  toTimeString
} from "@/utils/asesmenIntensifDateTime";

const JAM_CARRIER = toDateString(new Date()) || "2000-01-01";

@Component({
  components: { VCDateTimePicker, Monitoring24JamIcuNyeriInput },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class Monitoring24JamIcuHourlyDialog extends Vue {
  @Prop() value!: boolean;
  @Prop() monitoringId!: number;
  @Prop({ default: null }) editItem!: any;
  // Total Comfort Scale (section J) — sumber skor sedasi (auto-generate,
  // feedback Tim IRI 2026-07)
  @Prop({ default: null }) comfortTotal!: number | null;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  saving = false;
  deleting = false;

  form: any = {};

  kesadaranOptions = [
    "CM",
    "Apatis",
    "Somnolen",
    "Sopor",
    "Koma",
    "Tersedasi"
  ];

  refleksOptions = ["Positif", "Negatif"];

  reaksiOptions = [
    { text: "+ (reaktif)", value: "+" },
    { text: "- (non-reaktif)", value: "-" },
    { text: "Sluggish", value: "sluggish" }
  ];

  gcsItems = {
    e: ["1", "2", "3", "4", "NT"],
    v: ["1", "2", "3", "4", "5", "NT"],
    m: ["1", "2", "3", "4", "5", "6", "NT"]
  };

  timeCache = new Map<string, Date>();

  get waktuDate(): Date | null {
    const jam = String(this.form.waktu || "")
      .trim()
      .slice(0, 5);
    if (!jam) return null;
    const key = "t:" + jam;
    if (!this.timeCache.has(key)) {
      const d = composeDate(JAM_CARRIER, jam);
      if (!d) return null;
      this.timeCache.set(key, d);
    }
    return this.timeCache.get(key) || null;
  }

  setWaktu(val: Date | null) {
    this.$set(this.form, "waktu", toTimeString(val) || null);
  }

  recalcGcs() {
    const e = this.form.gcs_e;
    const v = this.form.gcs_v;
    const m = this.form.gcs_m;
    if (e === "NT" || v === "NT" || m === "NT") {
      this.form.gcs_total = "NT";
      return;
    }
    const vals = [e, v, m];
    if (vals.every(x => x !== null && x !== undefined && x !== "")) {
      this.form.gcs_total = String(Number(e) + Number(v) + Number(m));
    } else {
      this.form.gcs_total = null;
    }
  }

  get show() {
    return this.value;
  }
  set show(val: boolean) {
    this.$emit("input", val);
  }

  get isEdit() {
    return !!this.editItem && this.editItem.id;
  }

  get autoMap() {
    const sys = Number(this.form.td_sistole);
    const dia = Number(this.form.td_diastole);
    if (!sys || !dia) return "";
    return Math.round(dia + (sys - dia) / 3);
  }

  @Watch("value")
  onOpen(val: boolean) {
    if (val) {
      if (this.editItem && this.editItem.id) {
        this.form = {
          ...this.editItem,
          waktu:
            this.pad2(this.editItem.jam) +
            ":" +
            this.pad2(this.editItem.menit || 0)
        };
      } else {
        this.resetForm();
        const now = new Date();
        this.form.waktu =
          this.pad2(now.getHours()) + ":" + this.pad2(now.getMinutes());
      }
      // Skor sedasi di-generate dari total Comfort Scale (J) — bila J sudah
      // diisi, nilai terbaru selalu menimpa (field readonly di form)
      if (this.comfortTotal !== null && this.comfortTotal !== undefined) {
        this.form.skor_sedasi = this.comfortTotal;
      }
    }
  }

  pad2(n: number) {
    return String(n || 0).padStart(2, "0");
  }

  resetForm() {
    this.form = {
      waktu: null,
      map: null,
      td_sistole: null,
      td_diastole: null,
      hr: null,
      temp: null,
      kesadaran: null,
      refleks_tangan_kanan: null,
      refleks_tangan_kiri: null,
      refleks_kaki_kanan: null,
      refleks_kaki_kiri: null,
      irama_ekg: null,
      skor_nyeri: null,
      nyeri_metode: null,
      skor_sedasi: null,
      cvp_ra: null,
      pap_lap: null,
      spo2: null,
      tpm_hr: null,
      tipe_ventilasi: null,
      fio2: null,
      flow: null,
      rox: null,
      rr: null,
      vte: null,
      pip_p_platau: null,
      peep_cpap: null,
      menit_volume: null,
      pola_ventilasi: null,
      pupil_r_ukuran: null,
      pupil_l_ukuran: null,
      pupil_r_reaksi: null,
      pupil_l_reaksi: null,
      gcs_e: null,
      gcs_v: null,
      gcs_m: null,
      gcs_total: null
    };
  }

  close() {
    this.show = false;
    this.resetForm();
  }

  async simpan() {
    if (this.readOnly) return;
    if (!this.form.waktu) {
      appModule.NoticeDelay("Waktu harus diisi");
      return;
    }
    this.saving = true;
    try {
      const [jam, menit] = String(this.form.waktu)
        .split(":")
        .map(Number);
      const payload: any = { ...this.form, jam, menit };
      // Buang field non-input bawaan editItem — petugas_user_id di-set server
      // (Auth::id) dan objek petugas/td_formatted bukan kolom input
      delete payload.waktu;
      delete payload.id;
      delete payload.td_formatted;
      delete payload.petugas;
      delete payload.petugas_user_id;
      if (this.isEdit) {
        payload.hourly_id = this.editItem.id;
      }
      const resp = await Monitoring24JamIcuSvc.upsertHourly(
        this.monitoringId,
        payload
      );
      if (resp && resp.data && resp.data.status === "1") {
        appModule.NoticeDelay(
          this.isEdit ? "Data jam diperbarui" : "Data jam disimpan"
        );
        this.$emit("saved", resp.data.data);
        this.close();
      }
    } finally {
      this.saving = false;
    }
  }

  async hapus() {
    if (this.readOnly) return;
    if (!this.isEdit) return;
    if (!confirm(`Hapus data waktu ${this.form.waktu}?`)) return;
    this.deleting = true;
    try {
      const resp = await Monitoring24JamIcuSvc.deleteHourly(
        this.monitoringId,
        this.editItem.id
      );
      if (resp && resp.data && resp.data.status === "1") {
        appModule.NoticeDelay("Data jam dihapus");
        this.$emit("saved");
        this.close();
      }
    } finally {
      this.deleting = false;
    }
  }
}
